module.exports = __webpack_public_path__ + "static/img/好评-点击状态@4x.cc24d7a9.png";